import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'


class MobileTemplate extends Component {

  state = {
    createdAt: "",
    updatedAt: "",
    template_type: "",
    market_type: "",
    content: "",
    title: "",
    id: 0,
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = { 
        createdAt: props.mobile_template.createdAt,
        updatedAt: props.mobile_template.updatedAt,
        template_type: props.mobile_template.template_type,
        market_type: props.mobile_template.market_type,
        content: props.mobile_template.content,
        title: props.mobile_template.title,
        id: props.mobile_template.id,
    };
  }

  formatDate(date, isDateTime) {
    return new Intl.DateTimeFormat("de-DE", isDateTime ? {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
        hour:  "2-digit",
        minute: "2-digit",
       second: "2-digit"
    } : {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
    }).format(new Date(date))
  }
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    let elements = React.Children.toArray(this.props.children)
    let updateButton
    if(elements.length === 1){
        // deleteButton = React.cloneElement(elements[0], {id: this.state.id})
        updateButton = React.cloneElement(elements[0], {id: this.state.id, state: this.state})
    }

    return (
        <tr>
            <td>{this.state.id}</td>
            {/* <td><div>{token && !this.props.locked ?
                <input
                value={this.state.translation}
                onChange={e => this.setState({translation: e.target.value})}
                type="text"
                placeholder="translation"
                /> : this.state.translation}</div></td> */}
            <td><div>{this.state.template_type}</div></td>
            <td><div>{this.state.market_type}</div></td>
            <td><div>{token && !this.props.locked ?
                <textarea 
                style={{
                  width: 500
                  }}
                rows={5}
                value={this.state.content}
                onChange={e => this.setState({content: e.target.value})}
                type="text"
                placeholder="content"
                /> : this.state.content}</div></td>
            <td><div>{token && !this.props.locked ?
                  <input
                  style={{
                    width: 500
                    }}
                  value={this.state.title}
                  onChange={e => this.setState({title: e.target.value})}
                  type="text"
                  placeholder="title"
                  /> : this.state.title}</div></td>
            <td><div>{this.formatDate(this.state.createdAt, true)}</div></td>
            <td><div>{this.formatDate(this.state.updatedAt, true)}</div></td>
            {token && !this.props.locked && <td>{ updateButton }</td>}
            {/* {token && !this.props.locked && <td>{ deleteButton }</td>} */}
        </tr>
        )
    } 

}

export default MobileTemplate